var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.647,
    height: 12.004,
    viewBox: "0 0 18.647 12.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6106",
    "data-name": "Path 6106",
    d: "M47.288,68.595c0-.05.008-.1.008-.15A4.866,4.866,0,0,0,42.435,63.6a4.809,4.809,0,0,0-4.345,2.76,2.45,2.45,0,0,0-1.116-.266,2.566,2.566,0,0,0-2.452,2.164A3.806,3.806,0,0,0,32,71.85,3.745,3.745,0,0,0,35.729,75.6h5.261V69.519l-2.277,2.268-.483-.483,3.1-3.093,3.1,3.093-.491.483-2.285-2.268V75.6h5.578a3.444,3.444,0,0,0,3.413-3.446A3.5,3.5,0,0,0,47.288,68.595Z",
    transform: "translate(-32 -63.6)",
    fill: "#3D7CC9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.b1e2c2fcabbc759b1cb69c61d52e28bd.svg";
export { ForwardRef as ReactComponent };